import React, { useContext, useEffect, useRef, useState } from 'react';
import "./styles.sass"
// @ts-ignore
import { LocalizationContext } from "react-localize";
import MvwIcon from 'Generic/MvIcon/MvIcon';
import {
    TransactionFilters,
    UsageTransactionFilters,
    BaseTransaction,
    TransactionsByUsage,
    TransactionFilter,
    UsageFilter
} from './types';
import { FilterSection } from './FilterSection';
import LocalizationService from "Services/localization.service";

export interface Props {
    mode: 'usage'|'transaction';
    filters: TransactionFilters|UsageTransactionFilters;
    onFilterChange: (filterType: TransactionFilter|UsageFilter, selection: string|number) => void;
    selected: TransactionFilters;
    onReset: () => void;
};

/**
 * TODO: Describe this component!
 */
const MvTransactionFilter = ({
    mode,
    filters,
    onFilterChange,
    selected,
    onReset,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { localize } = useContext(LocalizationContext);
    const localizationService = new LocalizationService();
    const containerRef = useRef<any>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if(containerRef.current !== null && !containerRef.current.contains(event.target)){
                setIsOpen(false);
            }
        }
      
        window.addEventListener("mousedown", handleClickOutside);
        return () => window.removeEventListener("mousedown", handleClickOutside);
      }, [isOpen]);

    const getFriendlyUsageType = (usageType: string) => {
      return localizationService.getUsageTypeNameFromJahia(usageType).value;
    };

    const getFriendlyTransactionType = (transactionType: string) => {
        const friendlyName = localizationService.getTransactionTypeNameFromJahia(transactionType);
        return friendlyName.value || friendlyName.key;
    };
  
      const filtersSection = () => {
        if (mode === 'transaction') {
            const castedFilters = filters as TransactionFilters;

            if (!castedFilters) return null;

            return (
                <>
                    <FilterSection
                        filters={(castedFilters[TransactionFilter.transactionYears] || []).sort((a, b) => (b as number) - (a as number))}
                        // heading={localize("static.content.trans-history-transaction-type")}
                        heading="Transaction Year"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.transactionYears, selection)}
                        selected={selected[TransactionFilter.transactionYears]}
                    />
                    <FilterSection
                        filters={(castedFilters[TransactionFilter.transactionTypes] || []).map(tT => getFriendlyTransactionType(tT as string))}
                        // heading={localize("static.content.trans-history-transaction-type")}
                        heading="Transaction Type"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.transactionTypes, selection)}
                        selected={selected[TransactionFilter.transactionTypes]}
                    />
                    <FilterSection
                        filters={castedFilters[TransactionFilter.contracts] || []}
                        // heading={localize("static.content.trans-history-contract")}
                        heading="Contract"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.contracts, selection)}
                        selected={selected[TransactionFilter.contracts]}
                    />
                    <FilterSection
                        filters={(castedFilters[TransactionFilter.usageYears] || []).sort((a, b) => (b as number) - (a as number))}
                        // heading={localize("static.content.trans-use-year")}
                        heading="Use Year"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.usageYears, selection)}
                        selected={selected[TransactionFilter.usageYears]}
                    />
                    <FilterSection
                        filters={(castedFilters[TransactionFilter.usageTypes] || []).map(uT => getFriendlyUsageType(uT as string))}
                        // heading={localize("static.content.trans-usage-type")}
                        heading="Usage Type"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.usageTypes, selection)}
                        selected={selected[TransactionFilter.usageTypes]}
                    />
                    {/* <FilterSection
                        filters={castedFilters[TransactionFilter.userName]}
                        // heading={localize("static.content.trans-username")}
                        heading="Username"
                        onFilterChange={(selection) => onFilterChange(TransactionFilter.userName, selection)}
                        selected={selected[TransactionFilter.userName]}
                    /> */}
                </>    
            );
        } else if (mode === 'usage') {
            const castedFilters = filters as UsageTransactionFilters;

            return (
                <>
                    <FilterSection
                        filters={castedFilters[UsageFilter.contracts] || []}
                        // heading={localize("static.content.trans-history-contract")}
                        heading="Contract"
                        onFilterChange={(selection) => onFilterChange(UsageFilter.contracts, selection)}
                        selected={selected[UsageFilter.contracts]}
                    />
                    <FilterSection
                        filters={castedFilters[UsageFilter.usageYears] || []}
                        // heading={localize("static.content.trans-history-use-year")}
                        heading="Use Year"
                        onFilterChange={(selection) => onFilterChange(UsageFilter.usageYears, selection)}
                        selected={selected[UsageFilter.usageYears]}
                    />

                    <FilterSection
                        filters={(castedFilters[UsageFilter.usageTypes] || []).map(uT => getFriendlyUsageType(uT))}
                        // heading={localize("static.content.trans-usage-type")}
                        heading="Usage Type"
                        onFilterChange={(selection) => onFilterChange(UsageFilter.usageTypes, selection)}
                        selected={selected[UsageFilter.usageTypes]}
                    />
                </>    
            );
        }
    };

    return (
        <div className='mv-transaction-filter' ref={containerRef}>
            <button 
                className='trigger-btn'
                onClick={() => setIsOpen(!isOpen)}
            >
                {localize("static.content.trans-history-filter")}
                <MvwIcon
                    height="14px"
                    width="14px"
                    icon="filter"
                    color="#ffffff"
                />
            </button>
            {isOpen && 
                <div className="filter-dropdown">
                        <div className="filters-section">
                            {filtersSection()}
                        </div>
                        <button
                            className="reset-btn"
                            onClick={onReset}
                        >
                            {localize("static.content.trans-history-reset")}
                        </button>
                </div>    
            }
        </div>
    );
};

export {
    MvTransactionFilter,
};
